import {toast} from 'react-toastify'
import {httpRutoken} from "./httpRutoken";

class EdsService {
    async getEds() {
        try {
            const {data} = await httpRutoken.post('/eds')
            return data
        } catch (e) {
            toast.error('Ошибка')
        }
    }

    async getReference() {
        try {
            const {data} = await httpRutoken.post('/reference')
            return data
        } catch (e) {
            toast.error('Ошибка')
        }
    }
}

export default new EdsService()
